"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PageForm;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _useDeviceInfo2 = _interopRequireDefault(require("../../utils/useDeviceInfo"));
var _FormBottomBar = _interopRequireDefault(require("../FormBottomBar"));
var _BusySpinner = _interopRequireDefault(require("../BusySpinner"));
var _excluded = ["children", "className", "hideEdit", "onSave"];
function PageForm(props) {
  var children = props.children,
    className = props.className,
    hideEdit = props.hideEdit,
    onSave = props.onSave,
    bottomBarProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var theme = (0, _material.useTheme)();
  var _useDeviceInfo = (0, _useDeviceInfo2.default)(),
    isMobile = _useDeviceInfo.isMobile;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    processing = _useState2[0],
    setProcessing = _useState2[1];
  var handleSave = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setProcessing(true);
            _context.next = 3;
            return onSave();
          case 3:
            // <-- we want all onSaves to be async
            setProcessing(false);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSave() {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, processing && /*#__PURE__*/_react.default.createElement(_BusySpinner.default, {
    withSkrim: true
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: className,
    paddingBottom: hideEdit ? theme.spacing(4) : theme.spacing(isMobile ? 25 : 15)
  }, children), !hideEdit && /*#__PURE__*/_react.default.createElement(_FormBottomBar.default, Object.assign({
    onSave: handleSave
  }, bottomBarProps)));
}